<section class="breadcrumb-section">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumb-title">
          <h1>Events</h1>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="circle-gradient overflow-hidden section-lg horizontal-tabs">
  <div class="container">
    <ul class="nav nav-pills justify-content-center flex-row" id="myTab" role="tablist">
      <li class="nav-item">
        <a class="nav-link text-center active" id="cultural-tab" data-bs-toggle="tab" href="#cultural" role="tab"
          aria-controls="cultural" aria-selected="true">Cultural</a>
      </li>
      <li class="nav-item">
        <a class="nav-link text-center" id="academic-tab" data-bs-toggle="tab" href="#academic" role="tab"
          aria-controls="academic" aria-selected="false">Academic</a>
      </li>
      <li class="nav-item">
        <a class="nav-link text-center" id="sports-tab" data-bs-toggle="tab" href="#sports" role="tab"
          aria-controls="sports" aria-selected="false">Sports</a>
      </li>
      <!-- <li class="nav-item">
        <a
          class="nav-link text-center"
          id="conferences-tab"
          data-bs-toggle="tab"
          href="#conferences"
          role="tab"
          aria-controls="conferences"
          aria-selected="false"
          >Conferences
        </a>
      </li> -->
      <!-- <li class="nav-item">
        <a
          class="nav-link text-center"
          id="technical-tab"
          data-bs-toggle="tab"
          href="#technical"
          role="tab"
          aria-controls="technical"
          aria-selected="false"
          >Technical
        </a>
      </li> -->
      <!-- <li class="nav-item">
        <a
          class="nav-link text-center"
          id="workshops-tab"
          data-bs-toggle="tab"
          href="#workshops"
          role="tab"
          aria-controls="workshops"
          aria-selected="false"
          >Workshops &amp; Seminars
        </a>
      </li> -->
      <!-- <li class="nav-item">
                <a class="nav-link text-center " id="convocation-tab" data-bs-toggle="tab" href="#convocation" role="tab" aria-controls="convocation" aria-selected="false">Convocation Ceremony
                </a>
            </li> -->
    </ul>
    <div class="tab-content mt-5" id="myTabContent">
      <div class="tab-pane fade show active" id="cultural" role="tabpanel" aria-labelledby="cultural-tab">
        <div class="sec-title text-center mb-5 aos-init aos-animate" data-aos="zoom-in">
          <h2>Cultural</h2>
        </div>
        <div class="bg-white border-radius-sec mb-lg-5">
          <div class="row align-items-center g-0 row-cols-md-2 row-cols-1">
            <div class="col">
              <div class="px-lg-5 p-3">
                <div class="sec-title mb-3">
                  <h2><span>Farewell Party </span></h2>
                </div>
                <p>"Farewell Party 2026 at GHRCACS Nagpur was all about celebrating journeys, friendships, and the
                  moments that made college life unforgettable. From laughter and performances to heartfelt goodbyes,
                  every moment was filled with emotions and memories we’ll carry forward.

                  Here’s to new beginnings, bigger dreams, and a future full of success. " </p>
                <div class="text-center text-lg-start">
                  <a routerLink="/farewell" class="cmn-button">View More</a>
                </div>
              </div>
            </div>
            <div class="col text-center">
              <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-2.webp"
                class="img-fluid" alt="events | Raisoni Education" />
            </div>
          </div>
        </div>
        <div class="bg-white border-radius-sec mb-lg-5">
          <div class="row align-items-center flex-row-reverse g-0 row-cols-md-2 row-cols-1">
            <div class="col">
              <div class="px-lg-5 p-3">
                <div class="sec-title mb-3">
                  <h2><span>Chatrapati Shivaji Maharaj Jayanti </span></h2>
                </div>
                <p>
                  G H Raisoni College of Arts, Commerce and Science proudly
                  celebrated Chhatrapati Shivaji Maharaj Jayanti, honouring the
                  legacy of courage, leadership and visionary governance that
                  continues to inspire generations.
                </p>
                <div class="text-center text-lg-start">
                  <a routerLink="/chatrapati-shivaji-maharaj-jaynti" class="cmn-button">View More</a>
                </div>
              </div>
            </div>
            <div class="col text-center">
              <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/shivaji-jaynti-3.webp"
                class="img-fluid" alt="events | Raisoni Education" />
            </div>
          </div>
        </div>
        <div class="bg-white border-radius-sec mb-lg-5">
          <div class="row align-items-center g-0 row-cols-md-2 row-cols-1">
            <div class="col">
              <div class="px-lg-5 p-3">
                <div class="sec-title mb-3">
                  <h2><span>Kashti inauguration </span></h2>
                </div>
                <p>
                  GHRSTU, Nagpur and GHRCACS, Nagpur welcomed Kashti with
                  vibrant performances, artistic expression, and a celebration
                  of cultural talent.
                </p>
                <div class="text-center text-lg-start">
                  <a routerLink="/kashti-inauguration" class="cmn-button">View More</a>
                </div>
              </div>
            </div>
            <div class="col text-center">
              <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/kashti-2.webp"
                class="img-fluid" alt="events | Raisoni Education" />
            </div>
          </div>
        </div>

        <!-- <div class="bg-white border-radius-sec mb-lg-5">
                    <div class="row align-items-center g-0 row-cols-md-2 row-cols-1 ">
                        <div class="col">
                            <div class="px-lg-5  p-3 ">
                                <div class="sec-title mb-3">
                                    <h2><span>Ganesh Sthapna
                                        </span>
                                    </h2>
                                </div>
                                <p>GHRCEM, Nagpur marked the beginning of Ganesh Utsav with the auspicious Ganesh
                                    Sthapna, spreading positivity, devotion, and festive spirit across the campus. The
                                    celebration brought students and faculty together in joy and cultural unity.</p>
                                <div class="text-center text-lg-start">
                                    <a routerLink="/ganesh-utsav" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrietn/images/events/ganesh-sthapna-1.webp"
                                class="img-fluid" alt="events | Raisoni Education">
                        </div>
                    </div>
                </div> -->
        <!--
                <div class="bg-white border-radius-sec mb-lg-5">
                    <div class="row align-items-center g-0 row-cols-md-2 row-cols-1 ">
                        <div class="col">
                            <div class="px-lg-5  p-3 ">
                                <div class="sec-title mb-3">
                                    <h2><span>Laxmi Pujan</span>
                                    </h2>
                                </div>
                                <p>GHRCEM, Nagpur celebrated Laxmi Pujan with reverence and gratitude, marking the
                                    occasion as a symbol of prosperity, wisdom, and new beginnings. The celebration
                                    reflected the timeless belief that true wealth lies in knowledge, harmony, and
                                    collective progress.</p>
                                <div class="text-center text-lg-start">
                                    <a routerLink="/laxmi-pujan" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrietn/images/events/laxmi-puja-3.webp"
                                class="img-fluid" alt="events | Raisoni Education">
                        </div>
                    </div>
                </div> -->
        <!-- <div class="bg-white border-radius-sec mb-lg-5">
                    <div class="row align-items-center   g-0 row-cols-md-2 row-cols-1 ">
                        <div class="col">
                            <div class="px-lg-5  p-3 ">
                                <div class="sec-title mb-3">
                                    <h2><span>Kashti</span>
                                    </h2>
                                </div>
                                <p>We at the Raisoni believe in carving every niche in the curriculum of our
                                    institute which makes sure to enable a comprehensive development of the
                                    students. Immense is taken care with respect to the academics and cultural
                                    front. Yet again, our institute also emphasizes on personality development.
                                    Thus, a plethora of cultural events are organized, ensuring the complete
                                    growth of our student</p>
                                <p>One such event hosted by us is Kashti!</p>
                                <div class="text-center text-lg-start">
                                    <a routerLink="/kashti" class="cmn-button">View More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <img src="  https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/events/kashti/kashti4.webp"
                                class="img-fluid" alt="events | Raisoni Education">
                        </div>
                    </div>
                </div> -->
      </div>
      <div class="tab-pane fade" id="academic" role="tabpanel" aria-labelledby="academic-tab">
        <div class="sec-title text-center mb-5 aos-init aos-animate" data-aos="zoom-in">
          <h2>Academic Events</h2>
        </div>
        <div class="bg-white border-radius-sec mb-lg-5">
          <div class="row align-items-center flex-row-reverse g-0 row-cols-md-2 row-cols-1 text-lg-start">
            <div class="col">
              <div class="px-lg-5 p-3">
                <div class="sec-title mb-3">
                  <h2>
                    <span> Toast Fest A Major Event of Toastmasters</span>
                  </h2>
                </div>
                <p>
                  GHRCACS, Nagpur proudly hosted Toast Fest as part of the
                  Toastmasters Club. A celebration where words found their power
                  and voices rose with confidence. From nervous first words to
                  standing ovations, every speech was a step toward leadership
                  and self-discovery.
                </p>
                <div class="text-center text-lg-start">
                  <a routerLink="/toastmasters" class="cmn-button">View More</a>
                </div>
              </div>
            </div>
            <div class="col text-center">
              <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/tostmaster-7.webp"
                class="img-fluid" alt="events | Raisoni Education" />
            </div>
          </div>
        </div>
        <div class="bg-white border-radius-sec mb-lg-5">
          <div class="row align-items-center g-0 row-cols-md-2 row-cols-1 text-lg-start">
            <div class="col">
              <div class="px-lg-5 p-3">
                <div class="sec-title mb-3">
                  <h2>
                    <span>RAHE – Raisoni Academy for Human Excellence program</span>
                  </h2>
                </div>
                <p>
                  RAHE – Raisoni Academy for Human Excellence at Mangalwari
                  Campus successfully conducted a Faculty Development Program
                  aimed at enhancing teaching excellence and professional
                  growth.
                </p>
                <div class="text-center text-lg-start">
                  <a routerLink="/rahe" class="cmn-button">View More</a>
                </div>
              </div>
            </div>
            <div class="col text-center">
              <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/rahe-7.webp"
                class="img-fluid" alt="events | Raisoni Education" />
            </div>
          </div>
        </div>
        <div class="bg-white border-radius-sec mb-lg-5">
          <div class="row align-items-center flex-row-reverse g-0 row-cols-md-2 row-cols-1 text-lg-start">
            <div class="col">
              <div class="px-lg-5 p-3">
                <div class="sec-title mb-3">
                  <h2>
                    <span> SETU 2026</span>
                  </h2>
                </div>
                <p>
                  SETU 2026 at GHRSTU, Nagpur strengthened the bridge between
                  industry and academia, creating opportunities for
                  collaboration, innovation, and future-ready talent.
                </p>
                <div class="text-center text-lg-start">
                  <a routerLink="/setu" class="cmn-button">View More</a>
                </div>
              </div>
            </div>
            <div class="col text-center">
              <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/setu-6.webp"
                class="img-fluid" alt="events | Raisoni Education" />
            </div>
          </div>
        </div>
        <div class="bg-white border-radius-sec mb-lg-5">
          <div class="row align-items-center g-0 row-cols-md-2 row-cols-1 text-lg-start">
            <div class="col">
              <div class="px-lg-5 p-3">
                <div class="sec-title mb-3">
                  <h2><span>Sada Gyaan - Lecture Series - AK Singh</span></h2>
                </div>
                <p>
                  GHRCACS, Nagpur hosted the SADA GYAN Series featuring Lt
                  General Ajai Kumar Singh, whose address offered valuable
                  perspectives on leadership, discipline, and national service.
                </p>
                <div class="text-center text-lg-start">
                  <a routerLink="/sada-gyan-series" class="cmn-button">View More</a>
                </div>
              </div>
            </div>
            <div class="col text-center">
              <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/sda-gayan-7.webp"
                class="img-fluid" alt="events | Raisoni Education" />
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane fade" id="sports" role="tabpanel" aria-labelledby="sports-tab">
        <div class="sec-title text-center mb-5 aos-init aos-animate" data-aos="zoom-in">
          <h2>Sports</h2>
        </div>
        <div class="bg-white border-radius-sec mb-lg-5">
          <div class="row align-items-center flex-row-reverse g-0 row-cols-md-2 row-cols-1">
            <div class="col">
              <div class="px-lg-5 p-3">
                <div class="sec-title mb-3">
                  <h2>
                    <span>Raisoni Premier League Inauguration & Prize Distribution
                      Ceremony
                    </span>
                  </h2>
                </div>
                <p>
                  GHRSTU, Nagpur hosted the Raisoni Premier League Inauguration
                  and Prize Distribution Ceremony for students of GHRCACS,
                  Nagpur, marking a spirited celebration of sportsmanship,
                  teamwork, and achievement.
                </p>
                <div class="text-center text-lg-start">
                  <a routerLink="/raisoni-premier-league" class="cmn-button">View More</a>
                </div>
              </div>
            </div>
            <div class="col text-center">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/raisoni-premier-leug-2.webp"
                class="img-fluid" alt="events | Raisoni Education" />
            </div>
          </div>
        </div>
      </div>

      <div class="tab-pane fade" id="conferences" role="tabpanel" aria-labelledby="conferences-tab">
        <div class="sec-title text-center mb-5 aos-init aos-animate" data-aos="zoom-in">
          <h2>Conferences</h2>
        </div>

        <div class="bg-white border-radius-sec mb-lg-5">
          <div class="row align-items-center text-lg-start g-0 row-cols-md-2 row-cols-1">
            <div class="col">
              <div class="px-lg-5 p-3">
                <div class="sec-title mb-3">
                  <h2><span>International Conference(ICACEBD-25)</span></h2>
                </div>
                <p>
                  GHRCEM, Nagpur proudly hosted the International Conference on
                  Advances in Computing, Electronics & Bioinformatics for
                  Sustainable Development (ICACEBD-25), bringing together global
                  researchers and experts to share groundbreaking ideas for a
                  smarter, sustainable future.
                </p>
                <div class="text-center text-lg-start">
                  <a routerLink="/international-conference" class="cmn-button">View More</a>
                </div>
              </div>
            </div>
            <div class="col text-center">
              <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrietn/images/events/international-conference1.webp"
                class="img-fluid" alt="events | Raisoni Education" />
            </div>
          </div>
        </div>
        <div class="bg-white border-radius-sec mb-lg-5">
          <div class="row align-items-center text-lg-start flex-row-reverse g-0 row-cols-md-2 row-cols-1">
            <div class="col">
              <div class="px-lg-5 p-3">
                <div class="sec-title mb-3">
                  <h2><span>T & P Cell HR Meet</span></h2>
                </div>
                <p>
                  GHRCEM, Nagpur’s Training & Placement Cell hosted an impactful
                  HR Meet, giving students direct exposure to industry insights
                  and hiring perspectives. Students engaged with HR
                  professionals to gain real-world hiring insights and
                  expectations.
                </p>
                <div class="text-center text-lg-start">
                  <a routerLink="/t-and-p-cell-hr-m-meet" class="cmn-button">View More</a>
                </div>
              </div>
            </div>
            <div class="col text-center">
              <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrietn/images/events/t-p-cell-hr-meet1.webp"
                class="img-fluid" alt="events | Raisoni Education" />
            </div>
          </div>
        </div>
        <div class="bg-white border-radius-sec mb-lg-5">
          <div class="row align-items-center text-lg-start g-0 row-cols-md-2 row-cols-1">
            <div class="col">
              <div class="px-lg-5 p-3">
                <div class="sec-title mb-3">
                  <h2><span>ToastMasters Club First Year Eng Dept</span></h2>
                </div>
                <p>
                  GHRCEM, Nagpur hosted a Toastmasters Club session to help
                  students sharpen their communication skills, build confidence,
                  and grow as future leaders.
                </p>
                <div class="text-center text-lg-start">
                  <a routerLink="/toastmasters-club" class="cmn-button">View More</a>
                </div>
              </div>
            </div>
            <div class="col text-center">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrietn/images/events/toastmasters-club_first-year-eng-dept-25-1.webp"
                class="img-fluid" alt="events | Raisoni Education" />
            </div>
          </div>
        </div>
      </div>

      <div class="tab-pane fade" id="technical" role="tabpanel" aria-labelledby="technical-tab">
        <div class="sec-title text-center mb-5 aos-init aos-animate" data-aos="zoom-in">
          <h2>Technical</h2>
        </div>
        <div class="bg-white border-radius-sec mb-lg-5">
          <div class="row align-items-center text-lg-start flex-row-reverse g-0 row-cols-md-2 row-cols-1">
            <div class="col">
              <div class="px-lg-5 p-3">
                <div class="sec-title mb-3">
                  <h2>
                    <span>SIH-25 Internal Hackathon(CSE Dept)B.Tech</span>
                  </h2>
                </div>
                <p>
                  GHRCEM, Nagpur hosted the SIH-25 Internal Hackathon for the
                  B.Tech CSE Department — a platform for innovation,
                  problem-solving, and hands-on coding challenges.
                </p>
                <div class="text-start">
                  <a routerLink="/sih-internal-hackathon" class="cmn-button">View More</a>
                </div>
              </div>
            </div>
            <div class="col text-center">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrietn/images/events/sih-25-internal-hackathon-btech-1.webp"
                class="img-fluid" alt="events | Raisoni Education" />
            </div>
          </div>
        </div>
        <div class="bg-white border-radius-sec mb-lg-5">
          <div class="row align-items-center text-lg-start g-0 row-cols-md-2 row-cols-1">
            <div class="col">
              <div class="px-lg-5 p-3">
                <div class="sec-title mb-3">
                  <h2><span>T & P Activity (A I Dept)</span></h2>
                </div>
                <p>
                  GHRCEM, Nagpur hosted an insightful Training & Placement
                  session for our A.I. students, where industry experts decoded
                  trends, skills, and career paths in the world of Artificial
                  Intelligence.
                </p>
                <div class="text-start">
                  <a routerLink="/t-p-activity" class="cmn-button">View More</a>
                </div>
              </div>
            </div>
            <div class="col text-center">
              <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrietn/images/events/t-p-activity-ai-dept1.webp"
                class="img-fluid" alt="events | Raisoni Education" />
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane fade" id="workshops" role="tabpanel" aria-labelledby="workshops-tab">
        <div class="sec-title text-center mb-5 aos-init aos-animate" data-aos="zoom-in">
          <h2>Workshops</h2>
        </div>

        <div class="bg-white border-radius-sec mb-lg-5">
          <div class="row align-items-center g-0 row-cols-md-2 row-cols-1">
            <div class="col">
              <div class="px-lg-5 p-3">
                <div class="sec-title mb-3">
                  <h2><span>Garba Workshop(Data Sci Dept) </span></h2>
                </div>
                <p>
                  GHRCEM, Nagpur hosted a Garba Workshop for the Data Science
                  Department — bringing rhythm, energy, and festive cheer to
                  campus.
                </p>
                <div class="text-center text-lg-start">
                  <a routerLink="/garba-workshop" class="cmn-button">View More</a>
                </div>
              </div>
            </div>
            <div class="col text-center">
              <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrietn/images/events/garba-workshop-3.webp"
                class="img-fluid" alt="events | Raisoni Education" />
            </div>
          </div>
        </div>
        <div class="bg-white border-radius-sec mb-lg-5">
          <div class="row align-items-center flex-row-reverse g-0 row-cols-md-2 row-cols-1 text-lg-start">
            <div class="col">
              <div class="px-lg-5 p-3">
                <div class="sec-title mb-3">
                  <h2>
                    <span>Forum Installation & Cyber Crime Awareness Workshop</span>
                  </h2>
                </div>
                <p>
                  GHRCEM, Nagpur conducted its Forum Installation along with a
                  Cyber Crime Awareness Workshop — combining student leadership
                  with essential learning on digital safety.
                </p>
                <div class="text-center text-lg-start">
                  <a routerLink="/cyber-crime-awareness" class="cmn-button">View More</a>
                </div>
              </div>
            </div>
            <div class="col text-center">
              <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrietn/images/events/cyber-crime-awar-1.webp"
                class="img-fluid" alt="events | Raisoni Education" />
            </div>
          </div>
        </div>
        <div class="bg-white border-radius-sec mb-lg-5 text-lg-start">
          <div class="row align-items-center g-0 row-cols-md-2 row-cols-1">
            <div class="col">
              <div class="px-lg-5 p-3">
                <div class="sec-title mb-3">
                  <h2><span>Workshop-BCA- Sci & Tech Dept</span></h2>
                </div>
                <p>
                  GHRCEM, Nagpur organised a hands-on workshop for BCA students,
                  bridging the gap between classroom theory and real-world
                  application.
                </p>
                <div class="text-center text-lg-start">
                  <a routerLink="/workshop-bca-tept" class="cmn-button">View More</a>
                </div>
              </div>
            </div>
            <div class="col text-center">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrietn/images/events/workshop-bca-sci--tech-dept1.webp"
                class="img-fluid" alt="events | Raisoni Education" />
            </div>
          </div>
        </div>
        <div class="bg-white border-radius-sec mb-lg-5 text-lg-start">
          <div class="row align-items-center flex-row-reverse g-0 row-cols-md-2 row-cols-1">
            <div class="col">
              <div class="px-lg-5 p-3">
                <div class="sec-title mb-3">
                  <h2><span>Institution Innovation Council</span></h2>
                </div>
                <p>
                  GHRCEM, Nagpur hosted the Institution Innovation Council to
                  promote innovation-led learning and support future
                  changemakers.
                </p>
                <div class="text-center text-lg-start">
                  <a routerLink="/institution-innovation-council" class="cmn-button">View More</a>
                </div>
              </div>
            </div>
            <div class="col text-center">
              <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrietn/images/events/insti-inno-cou1.webp"
                class="img-fluid" alt="events | Raisoni Education" />
            </div>
          </div>
        </div>
        <div class="bg-white border-radius-sec mb-lg-5 text-lg-start">
          <div class="row align-items-center text-lg-start g-0 row-cols-md-2 row-cols-1">
            <div class="col">
              <div class="px-lg-5 p-3">
                <div class="sec-title mb-3">
                  <h2><span>Skill Training Workshop(AI Dept)</span></h2>
                </div>
                <p>
                  GHRCEM, Nagpur hosted a Skill Training Workshop for students
                  from the AI department — focusing on practical learning,
                  applied skills, and industry relevance.
                </p>
                <div class="text-center text-lg-start">
                  <a routerLink="/skill-training-workshop" class="cmn-button">View More</a>
                </div>
              </div>
            </div>
            <div class="col text-center">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrietn/images/events/skill-training-workshop-ai-dept-25-2.webp"
                class="img-fluid" alt="events | Raisoni Education" />
            </div>
          </div>
        </div>
        <div class="bg-white border-radius-sec mb-lg-5 text-lg-start">
          <div class="row align-items-center flex-row-reverse g-0 row-cols-md-2 row-cols-1">
            <div class="col">
              <div class="px-lg-5 p-3">
                <div class="sec-title mb-3">
                  <h2>
                    <span>External Internship Seminar(Civil Eng Dept)B.Tech</span>
                  </h2>
                </div>
                <p>
                  GHRCEM, Nagpur hosted an external internship seminar for our
                  Civil Engineering department — a vital step in evaluating
                  field experience. Students demonstrated how hands-on exposure
                  is shaping their understanding of construction practices,
                  design thinking, and site-level decision-making.
                </p>
                <div class="text-center text-lg-start">
                  <a routerLink="/external-internship-seminar" class="cmn-button">View More</a>
                </div>
              </div>
            </div>
            <div class="col text-center">
              <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrietn/images/events/ext-intern-semi-civil-eng-dept-btech.webp"
                class="img-fluid" alt="events | Raisoni Education" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
